import { MissionToStaffMission } from '../../lib/types/models/mission-to-staff/mission-to-staff'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export async function getMissionToStaffMission(missionToStaffId: number) {
  return restApiClient
    .url(
      constructApiUrl(API.missionToStaffs.getMissionToStaffMission.url, { id: missionToStaffId })
    )
    .get<MissionToStaffMission>()
}
